var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4915 15.9917L14.8249 20.6583C14.3693 21.1139 13.6306 21.1139 13.175 20.6583L8.50829 15.9917C8.05268 15.5361 8.05268 14.7974 8.50829 14.3417C8.96391 13.8861 9.7026 13.8861 10.1582 14.3417L12.8333 17.0168V3.50004C12.8333 2.85571 13.3556 2.33337 13.9999 2.33337C14.6442 2.33337 15.1666 2.85571 15.1666 3.50004V17.0168L17.8416 14.3417C18.2972 13.8861 19.0359 13.8861 19.4915 14.3417C19.9472 14.7974 19.9472 15.5361 19.4915 15.9917Z",
    fill: "#475367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 20.4167C4.66659 19.7724 4.14425 19.25 3.49992 19.25C2.85559 19.25 2.33325 19.7724 2.33325 20.4167V22.1667C2.33325 24.744 4.42259 26.8334 6.99992 26.8334H20.9999C23.5772 26.8334 25.6666 24.744 25.6666 22.1667V20.4167C25.6666 19.7724 25.1442 19.25 24.4999 19.25C23.8556 19.25 23.3333 19.7724 23.3333 20.4167V22.1667C23.3333 23.4554 22.2886 24.5 20.9999 24.5H6.99992C5.71125 24.5 4.66659 23.4554 4.66659 22.1667V20.4167Z",
    fill: "#475367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e1037cc8d1af4275241bdbae8b9836c4.svg";
export { ForwardRef as ReactComponent };